import React from 'react';
import PropTypes from 'prop-types';

function Button({ options, onClick }) {
    let iconBeforeText = null;
    let iconAfterText = null;
    let loading = null;
    let text = null;

    const btnTypes = btnTypes => {
        let strBtnTypes = ' ';
        strBtnTypes =
            options.className !== undefined ? options.className + ' ' : '';
        if (btnTypes) {
            btnTypes.forEach(type => {
                switch (type) {
                    case 'secondary':
                        strBtnTypes += 'c-btn--secondary  ';
                        break;
                    case 'simple':
                        strBtnTypes += 'c-btn--simple  ';
                        break;
                    case 'link':
                        strBtnTypes += 'c-btn--link  ';
                        break;
                    case 'icon':
                        strBtnTypes += 'c-btn--icon  ';
                        break;
                    case 'icon-only':
                        strBtnTypes += 'c-btn--icon-only  ';
                        break;
                    case 'full':
                        strBtnTypes += 'c-btn--full  ';
                        break;
                    case 'small':
                        strBtnTypes += 'c-btn--small  ';
                        break;
                    case 'round':
                        strBtnTypes += 'c-btn--round  ';
                        break;
                    default:
                        break;
                }
            });
        }

        return strBtnTypes;
    };

    if (options.loading) {
        loading = (
            <div
                className="c-spinner  c-spinner--small u-inline-item"
                aria-live="polite"
                aria-busy="true"
            >
                <div className="c-spinner__loader">
                    <span className="c-spinner__element"></span>
                    <span className="c-spinner__element"></span>
                    <span className="c-spinner__element"></span>
                    <span className="c-spinner__element"></span>
                    <span className="c-spinner__element"></span>
                    <span className="c-spinner__element"></span>
                    <span className="c-spinner__element"></span>
                    <span className="c-spinner__element"></span>
                </div>
            </div>
        );
    }

    if (options.icon) {
        iconBeforeText = options.icon.isBeforeText ? (
            <i
                title={options.icon.title}
                className={
                    'c-btn__icon c-icon  c-icon--[' + options.icon.image + ']'
                }
            />
        ) : null;
        iconAfterText = options.icon.isAfterText ? (
            <i
                title={options.icon.title}
                className={
                    'c-btn__icon c-icon  c-icon--[' + options.icon.image + ']'
                }
            />
        ) : null;
    }

    if (options.text) {
        text = (
            <span className="c-btn__text" style={{ pointerEvents: 'none' }}>
                {options.text}
            </span>
        );
    }

    return (
        <button
            name={options.name}
            type={options.type}
            value={options.value}
            id={options.id}
            onClick={onClick ? e => onClick(e) : undefined}
            className={'c-btn  ' + btnTypes(options.btnTypes) + options.class}
            disabled={options.disabled}
            title={options.title}
        >
            {iconBeforeText}
            {text}
            {iconAfterText}
            {loading}
        </button>
    );
}

Button.propTypes = {
    options: PropTypes.shape({
        text: PropTypes.string,
        btnTypes: PropTypes.array,
        title: PropTypes.string,
        name: PropTypes.string,
        type: PropTypes.string,
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        loading: PropTypes.bool,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        icon: PropTypes.shape({
            isBeforeText: PropTypes.bool,
            isAfterText: PropTypes.bool,
            className: PropTypes.string,
            title: PropTypes.string,
        }),
        link: PropTypes.shape({}),
    }).isRequired,
    onClick: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

export default Button;
